const SentenceIcon = ({ size = 32, color = "#2699FB" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill={color}
        d="M14.06 9L15 5.5L16 2h2L17 5.5L16 9zm-4.12 0L11 5.5L12 2h2L13 5.5L12 9zM3 18v-2h18v2zm-1-5l4-11h2l4 11h-2.07l-.86-2.5h-4.14L4.07 13zm3.3-4.1h3.4L7 4h-.1z"
      />
    </svg>
  );
};

export default SentenceIcon;
